<div class="hue-slider-component">
  <mat-slider class="hue-slider" [min]="minValue" [max]="maxValue" #ngSlider>
    <input matSliderThumb [(ngModel)]="colorAngleValue" (change)="emitHueChange()" #ngSliderThumb="matSliderThumb" />
  </mat-slider>
</div>
